import {
    IVideoPlayerStrategy
} from "../../video-player.strategy.interface";

export class NativeVideoStreamingStrategy implements IVideoPlayerStrategy {

    constructor(private videoElement: HTMLVideoElement) {
    }

    get isPlaying(): boolean {
        return !this.videoElement.paused;
    }

    private _updateSrc(src: string): boolean {
        if(this.videoElement.src !== src) {
            this.videoElement.src = src;
            return true;
        } else {
            return false;
        }
    }

    async preload(src: string): Promise<void> {
        if(this._updateSrc(src)) {
            this.videoElement.load();
        }
    }

    async play(src: string): Promise<void> {
        this._updateSrc(src);
        await this.videoElement.play();
    }

    async retryPlay(): Promise<void> {
        const src = this.videoElement.src;
        this.videoElement.src = "";
        this.videoElement.load();
        await this.play(src);
    }

    pause(): void {
        if(this.isPlaying) {
            this.videoElement.pause();
        }
    }

    async resume(): Promise<void> {
        if(this.videoElement.src && !this.isPlaying) {
            await this.videoElement.play();
        }
    }

    destroy(): void {
        this.videoElement = null;
    }

}